<template> 
  <v-layout 
    column 
    v-scroll="onScroll" 
    fill-height>  
      <!-- NAVIGATION DRAWER -->
      <not-navbar :not="not" :navOpen="navOpen"/>  
      <not-header :not="not" @novOpen="navOpen=!navOpen"/> 
      <!-- MAIN BODY        -->
      <v-content class="b1">
        <v-layout column  >
          <router-view :not="not"/>  
        </v-layout> 
      </v-content>
      <not-footer :not="not"/> 
      <not-dialog
        @notNo="onNotNoDialog()" 
        @notYes="onNotYesDialog()"/> 
      <not-dialog-p/> 
  </v-layout> 
</template>

<script>
    let pageName = 'MainActivity' 
    import browser from 'browser-detect' 
    export default{
        // props:["not"],
        name: pageName, 
        data () {
          return { 
            navOpen:false,
            scrolled:null,
            imgLazy:require(`@/assets/system/no-image.png`)
          } 
        }, 
        created(){ 
          this.$store.dispatch('fi_add_visiter',{
            data:browser()
          })
        },
        mounted(){ 
          this.$store.dispatch('setToolbar',{
            tbColor:'transparent',
            tbFlat:true
          })
        }, 
        computed: {
          vs(){
            return this.$vuetify.breakpoint
          }, 
          vsn(){
            return this.vs.name
          },
          appName(){
            return this.$store.getters.getAppName
          }, 
          us(){
            let returnUser = this.$store.getters.getUser
            return returnUser
          }, 
          ud(){
            let returnUser = this.$store.getters.getUserD
            return returnUser
          },
          loadedPages(){ 
            const ld = this.$store.getters.getLoadedPages 
            return ld
          },
          loading(){ 
            const loading = this.$store.getters.getLoading
            return loading
          },
          processes(){ 
            const process = this.$store.getters.getProcesses
            return process
          }, 
          responses(){ 
            const re = this.$store.getters.getResponses
            return re
          },
          TOTAL_C(){ 
            const re = this.$store.getters.getTotalC
            return re
          },
          not(){
            return {
              imgLazy:this.imgLazy,
              noImg:this.imgLazy,
              vs:this.vs,
              vsn:this.vsn,
              appName:this.appName,
              pagination:this.pagination,
              NotHeader:this.NotHeader,
              NotHeaderNT:this.NotHeaderNT,
              go:this.go,
              logout:this.logout, 
              restartResponses:this.restartResponses,
              dynamicSort:this.dynamicSort,
              size:this.size,
              convertDate:this.convertDate,

              us:this.us,
              ud:this.ud,
              loadedPages:this.loadedPages,
              loading:this.loading,
              processes:this.processes,
              responses:this.responses,
              notDialog:this.notDialog,
              notDialogP:this.notDialogP,
              TOTAL_C:this.TOTAL_C,

              //CONVERT
              convertDate:this.convertDate,
              convertTime:this.convertTime,
              CONVERT_STRING_TO_INT:this.CONVERT_STRING_TO_INT,
              CONVERT_STRING_TO_DATE_STRING:this.CONVERT_STRING_TO_DATE_STRING,

              //TEXT
              TEXT_UP:this.TEXT_UP,
              TEXT_UP1:this.TEXT_UP1,
              TEXT_UP11:this.TEXT_UP11,
              TEXT_UP0:this.TEXT_UP0,

              ARRAY_F:this.ARRAY_F,
              TEXT_SPLIT_N:this.TEXT_SPLIT_N,

              //TABLE HEADER 
              TABLE_HEADERS : this.TABLE_HEADERS,
              CREATE_TABLE_HEADER : this.CREATE_TABLE_HEADER,
              TABLE_HEADER_SHOW : this.TABLE_HEADER_SHOW,
              TABLE_HEADER_SELECTOR : this.TABLE_HEADER_SELECTOR,

              //CODE
              CODE_IS_OK:this.CODE_IS_OK,
              CODE_IS_AUTO:this.CODE_IS_AUTO,
              CODE_AUTO_GENERATE:this.CODE_AUTO_GENERATE,
              CODE_GET_FIRST:this.CODE_GET_FIRST,
              CODE_GET_LAST:this.CODE_GET_LAST,
              CODE_CHECK:this.CODE_CHECK,

              //JOIN
              JOIN_CONGREGATION:this.JOIN_CONGREGATION,
              JOIN_SISTERS:this.JOIN_SISTERS,
              JOIN_VISITER:this.JOIN_VISITER,
              JOIN_COMMUNITIES:this.JOIN_COMMUNITIES,
              JOIN_NEWS:this.JOIN_NEWS,
              selectorNames:this.selectorNames,
              selectorCodeName:this.selectorCodeName,
              selectorNamesCode:this.selectorNamesCode,
            }
          },
        },

        //---------------methods-----------------//
        methods: { 
            onScroll (e) { 
              this.scrolled = window.pageYOffset || document.documentElement.scrollTop  
              if (this.scrolled>200) { 
                    this.$store.dispatch('setToolbar',{})
                } else { 
                    this.$store.dispatch('setToolbar',{
                      tbColor:'transparent',
                      tbFlat:true
                    })
                }
            },
            pagination(list,page,size){
                let total = list.length
                let pages = total/size
                let faction = page/pages
                let last = faction*total
                let start = last-size
                //console.log("t:"+total+" f:"+faction+" p:"+pages+" p:"+page+" l:"+last+" s:"+start); 
                return {
                    list:list.slice(start,last),
                    total:total,
                    pages:Math.ceil(pages),
                    start:start,
                    last:last
                }
            },
            NotHeader(notShow,notType,notHeight,notText,notIcon,notIndicators,notImages,notAction){
              let not={
                notShow:notShow,
                notType: notType,
                notHeight: notHeight,
                notText: notText,
                notIcon: notIcon,
                notIndicators: notIndicators,
                notImages:notImages,
                notAction: notAction
              } 
              this.$store.dispatch("setNotHeader",not)
            },
            NotHeaderNT(nt){  
              this.NotHeader(nt.notShow,nt.notType,nt.notHeight,nt.notText,nt.notIcon,
                  nt.notIndicators,nt.notImages,nt.notAction)
            },
            //not dialog show
            notDialog(notShow,notHd,notH,notTx,notNoTx,notYesTx,notAction){
                this.$store.dispatch('setNotDialog',{
                    notShow : notShow,
                    notHd : notHd,
                    notH : notH,
                    notTx : notTx,
                    notNoTx : notNoTx,
                    notYesTx : notYesTx,
                    notAction:notAction
                }) 
            },
            notDialogP(notShow,notHd,notTx,notCl){
                this.$store.dispatch('setNotDialogP',{
                    notShow : notShow,
                    notHd : notHd,
                    notTx : notTx,
                    notCl : notCl
                })  
            },
            dynamicSort(property,asc){
              var sortOrder = 1;
              if(property[0] === "-") {
                  sortOrder = -1;
                  property = property.substr(1);
              }
              return function (a,b) {
                  /* next line works with strings and numbers, 
                  * and you may want to customize it to your needs
                  */
                  var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                  if (asc) {
                    return result * sortOrder;
                  }else{
                    return -1 * (result * sortOrder);
                  } 
              }
            },
            go(to){
              this.$router.push(to)
            },
            logout(){
              this.$store.dispatch("fi_signUserOut")
            }, 
            restartResponses(){
              this.$store.dispatch("restartResponses")
            },
            size(arr){
              return arr?arr.length:0
            },
            
            //CONVERT
            convertDate(s_date,numbers){ 
              if (!s_date) {
                return "00/00/0000"
              } 
              const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ];
              const montShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
              ];
              var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              var dayShortNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
              
              let date =  new Date(s_date);
              if (numbers) {
                date = new Date(0,0,s_date)
              }
              let newDate = ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' +((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' +  date.getFullYear()

              let newTime=(date.getHours())+":"+(date.getMinutes())
              return newDate+" "+newTime
            },
            convertTime(time){ 
              if (!time) {
                return "00:00"
              }  
              let date =  new Date(time); 
              let newTime=(date.getHours())+":"+(date.getMinutes())
              return  newTime
            },
            CONVERT_STRING_TO_DATE_STRING(s_date,){ 
              if (!s_date) {
                return "2020-01-01"
              }  
              let date =  new Date(s_date);  
              let newDate = 
                  (date.getFullYear())
                  + '-' +
                  ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)))
                  + '-' +
                  ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()))
                if (newDate.includes("NaN")) {
                  return "2020-01-01"
                }
              return newDate 
            },
            CONVERT_STRING_TO_INT(string){
              if (!string) {return 0}
              string = string.replace ( /[^\d.]/g, '' );
              return parseInt(string, 10)
            },

            TEXT_UP(text){
              if (!text) {return null}
              let tx = text.toUpperCase()
              return tx
            },
            TEXT_UP1(text){
              if (!text) {return null}
              let tx = text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
              return tx
            },
            TEXT_UP11(text){
              if (!text) {return null}
              var splitStr = text.toLowerCase().split(' ');
              for (var i = 0; i < splitStr.length; i++) { 
                  splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
              } 
              return splitStr.join(' '); 
            },
            TEXT_UP0(text){
              if (!text) {return null} 
              return text.toLowerCase(); 
            },

            TEXT_SPLIT_N(text){
              if(!text){return null}
              return text.split('\n')
            },

            ARRAY_F(list,size){
              if(!list){return null}
              if(!size){size = 1}
              return  list.slice(0, size)
            },

            //TABLE HEADERS
            CREATE_TABLE_HEADER(headers,type){
                if(!headers){return null}
                if (!(headers instanceof Array)) {  return false } 

                let newHeaders = []
                headers.forEach(element => {
                    if (element.show) {
                        if (!type) {
                            newHeaders.push({
                                text:this.TEXT_UP(element.text?element.text:element.name),
                                value:this.TEXT_UP0(element.value?element.value:element.name),
                                align:element.align?element.align:'left',
                                sortable:element.sortable===false?false:true
                            }) 
                        }else if (type===1) {
                            newHeaders.push({
                                text:this.TEXT_UP1(element.text?element.text:element.name),
                                value:this.TEXT_UP0(element.value?element.value:element.name),
                                align:element.align?element.align:'left',
                                sortable:element.sortable===false?false:true
                            }) 
                        }else if (type===11) {
                            newHeaders.push({
                                text:this.TEXT_UP11(element.text?element.text:element.name),
                                value:this.TEXT_UP0(element.value?element.value:element.name),
                                align:element.align?element.align:'left',
                                sortable:element.sortable===false?false:true
                            }) 
                        }else if (type===0) {
                            newHeaders.push({
                                text:this.TEXT_UP0(element.text?element.text:element.name),
                                value:this.TEXT_UP0(element.value?element.text:element.name),
                                align:element.align?element.align:'left',
                                sortable:element.sortable===false?false:true
                            }) 
                        } 
                    }
                    
                });
                return newHeaders
            },
            TABLE_HEADERS(customeHeader){ 
              let headers = []
                //general
                if (this.TABLE_HEADER_SHOW(customeHeader,'Image')) {
                    headers.push({ text: '',align: 'left', value: 'image',sortable: false})
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Number')) {
                    headers.push({ text: 'NO.',align: 'left', value: 'no',sortable: true})
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Name')) {
                    headers.push({ text: 'NAME',align: 'left', value: 'name',sortable: true})
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Initials')) {
                    headers.push({ text: 'INITIALS',align: 'left', value: 'initials',sortable: true})
                }

                //Abserver 
                if (this.TABLE_HEADER_SHOW(customeHeader,"First Name")) {
                    headers.push({ text: 'FIRST NAME',  value: 'first_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Surname")) {
                    headers.push({ text: 'SURNAME',  value: 'surname',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Phone Number")) {
                    headers.push({ text: 'PHONE',  value: 'phone_number',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Email Address")) {
                    headers.push({ text: 'EMAIL',  value: 'email_address',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Location Address")) {
                    headers.push({ text: 'LOCATION ADDRESS',  value: 'location_address',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Post Address")) {
                    headers.push({ text: 'POST ADDRESS',  value: 'post_address',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Community")) {
                    headers.push({ text: 'COMMUNITY',  value: 'community',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Apostolate")) {
                    headers.push({ text: 'APOSTOLATE',  value: 'apostolate',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Congregation")) {
                    headers.push({ text: 'CONGREGATION',  value: 'congregation_name',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Position")) {
                    headers.push({ text: 'POSITION',  value: 'position',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Age')) {
                    headers.push({ text: 'AGE', value: 'age',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Staff')) {
                    headers.push({ text: 'STAFF', value: 'staff',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Date of Birth')) {
                    headers.push({ text: 'BIRTHDAY', value: 'date_of_birth',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Date of First Vows')) {
                    headers.push({ text: 'FIRST VOWS', value: 'date_of_first_vows',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Level Of Education')) {
                    headers.push({ text: 'EDUCATION', value: 'level_of_education',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Code')) {
                    headers.push({ text: 'CODE', value: 'code',sortable: true},)
                } 

                //added / created 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Added By")) {
                    headers.push({ text: 'ADDED BY',  value: 'user_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Added At")) {
                    headers.push({ text: 'ADDED AT',  value: 'created_at',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Updated At")) {
                    headers.push({ text: 'UPDATED AT',  value: 'updated_at',sortable: true},)
                }

                 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Image Link")) {
                    headers.push({ text: 'IMAGE LINK', value: 'image_link',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"ACTION")) {
                    headers.push({ text: 'ACTION',align: 'center', value: 'action',sortable: false })
                }
              return headers
            },
            TABLE_HEADER_SHOW(headers,name){  
                if (!headers) {return false}
                if (!(headers instanceof Array)) { 
                  return false
                } 
                
                let hd = headers.find(item=>{
                    return item.name == name
                })
                if (!hd) {return false} 
                return hd.show
            },
            TABLE_HEADER_SELECTOR(headers,index){   
                if (!headers) {return}
                if (!index) {return} 
                let hd = headers.hasOwnProperty(index)
                if (hd) {
                  headers[index].show = !headers[index].show
                }
            },
            //CODE
            CODE_IS_OK(array){
              if(!array){return false}
              let isOk = true
              array.forEach(element => {
                let code = element.code
                if (!code) {
                  isOk = false
                }else if (code ==='') {
                  isOk = false
                }else if (code ==='0') {
                  isOk = false
                }else if (code ===0) {
                  isOk = false
                }
              });
              return isOk
            },
            CODE_IS_AUTO(array){
              if(!array){return false}
              let isAuto = true
              let autoArray  = this.CODE_AUTO_GENERATE(array)
              
              for (const index in array) {
                let e_array = array[index]
                let e_autoArray = autoArray[index]
                let code = e_array?e_array.code:null
                let autoCode = e_autoArray?e_autoArray.code:null

                if (code !== autoCode) {
                  isAuto = false
                } 
              }

              return isAuto
            },
            CODE_AUTO_GENERATE(array){
              if(!array){return null}

              let newArray = []
              let code = 0
              array.forEach(element => {
                code = code+1
                newArray.push({
                  ...element,
                  code:code
                })
              });
              return newArray
            },
            CODE_GET_FIRST(array){
              if(!array){return 0}
              let first = 0
              let number = 0
              array.forEach(element => {
                number = number+1
                let code = element.code*1
                if (number === 1 ) {
                  first = code
                }
                
                if (code < first) {
                  first = code
                }
              });

              return first
            },
            CODE_GET_LAST(array){
              if(!array){return 0}
              let last = 0
              
              array.forEach(element => { 
                let code = element.code*1
                if (code > last) {
                  last = code
                }
              }); 
              return last
            },
            CODE_CHECK(array,code){
              if(!array){return false}
              if(!code){return false}
              
              let check = false 
              
              array.forEach(element => { 
                if (element.code ===code) {
                  check = true
                }
              }); 

              return check
            }, 

            JOIN_CONGREGATION(congregation){  
              if (!congregation) { 
                return null
              }  
              let newC = []
              let NUMBER = 0
              congregation.forEach(element => {
                NUMBER = NUMBER+1
                newC.push({
                  ...element,
                  no:NUMBER
                })
              });
              return newC
            },
            JOIN_SISTERS(sisters){  
              if (!sisters) { 
                return null
              }  
              let newSisters = []
              let NUMBER = 0
              sisters.forEach(element => {
                NUMBER = NUMBER+1
                //find User
                let uid = element.uid
                let user = this.$store.getters.getUserByUID(uid)
                let user_name =user?user.name:null 

                //find congregation
                let congregation_code = element.congregation_code
                let congregation = this.$store.getters.getCongregationByCode(congregation_code)
                let congregation_name = congregation?congregation.name:"?:"+congregation_code
                newSisters.push({
                  ...element,
                  no:NUMBER,
                  first_name:this.TEXT_UP11(element.first_name),
                  surname:this.TEXT_UP11(element.surname),
                  name:this.TEXT_UP11(element.first_name+" "+element.surname),
                  congregation:congregation,
                  congregation_name:this.TEXT_UP11(congregation_name),
                  created_at:this.convertDate(element.created_at),
                  updated_at:this.convertDate(element.updated_at),
                  user_name:this.TEXT_UP11(user_name),
                })
              });
              return newSisters
            },
            JOIN_VISITER(visiter){
                if(!visiter){return null}
                let JOIN = []
                let NUMBER = 0

                visiter.forEach(element => {
                    NUMBER = NUMBER+1
                    let revisitC = ()=>{
                        let obj = element.revisit
                        let newData = []
                        let i = 1
                        for (const key in obj) {
                            let sms = obj[key]
                            newData.push({
                                i:i,
                                key: key,
                                ...sms
                            })
                            i++
                        }
                        return newData
                    }
                    let revisit = revisitC()
                    let last =revisit?revisit[revisit.length -1]:null
                
                    let newVisiter = {
                        ...element,
                        no:NUMBER,
                        device:element.mobile?"Phone":"Desktop",
                        device_icon:element.mobile?"mdi-cellphone-iphone ":"mdi-monitor ",
                        location_country:element.location?element.location.country:'',
                        location_city:element.location?element.location.city:'',
                        total_revisit:revisit?revisit.length:'0',
                        last_visit:last?this.convertDate(last.date):this.convertDate(element.date),
                        first_visit:this.convertDate(element.date),
                        revisit:revisit
                    } 
                    JOIN.push(newVisiter) 
                });

                return JOIN
            },
            JOIN_COMMUNITIES(sisters){  
              if (!sisters) { 
                return null
              }  
              //find communities
              let communities = []
              let NUMBER = 0
              sisters.forEach(element => {
                NUMBER = NUMBER+1
                let community = element.community
                let indexOfCommunity = communities.indexOf(community) 
                if (indexOfCommunity===-1) {
                  communities.push(community)
                }  
              });

              //join communities
              let join_communities = []
              communities.forEach(element => {
                join_communities.push({
                  name:element
                })
              });
              return join_communities
            },
            JOIN_NEWS(news){  
              if (!news) { 
                return null
              }  
              let newNews = []
              let NUMBER = 0
              news.forEach(element => {
                NUMBER = NUMBER+1
                //find User
                let uid = element.uid
                let user = this.$store.getters.getUserByUID(uid)
                let user_name =user?user.name:null 

                //  ...
                newNews.push({
                  ...element,
                  no:NUMBER, 
                  created_at:this.convertDate(element.created_at),
                  updated_at:this.convertDate(element.updated_at),
                  user_name:this.TEXT_UP11(user_name),
                })
              });
              return newNews
            },

            //-------------------[SELECTOR]--------------------
            selectorNames(array){
              if (!array) {
                return null
              }
              let names =[]
              array.forEach(ar => {
                names.push(ar.i+". "+ar.name)  
              }); 
              return names
            },
            selectorCodeName(array,code){
              if (!array) {
                return null
              }
              if (!code) {
                return null
              }
              let item = array.find(ar => {
                return ar.code == code  
              }); 
              if (!item) {
                return null
              }
              return item.i+". "+item.name
            },
            selectorNamesCode(array,name){
              if (!name) {
                return null
              }
              if (!array) {
                return null
              }
              name = ''+name 
              if (!name.includes(". ")) { 
                return name
              } 
              
              let i = name.split(". ")[0]
              let item = array.find(it=>{
                return it.i == i
              })
              return item.code
            },
             
        },
        watch:{ 

        }   
    }
    
</script>

<style>
  
  
</style>
